import { useQuery, queryOptions } from '@tanstack/vue-query';
import { computed, unref, type MaybeRef } from 'vue';
import httpClient from '../httpClient';
import type { MantaClient } from '@/types';

export const useClient = (
  clientId: MaybeRef<string | undefined>,
  enabled?: MaybeRef<boolean>,
) => {
  const id = computed(() => unref(clientId));
  const isEnabled = computed(() => !!id.value && (unref(enabled) ?? true));

  return useQuery(
    queryOptions({
      queryKey: computed(() => ['scribeClient', id.value]),
      queryFn: async (): Promise<MantaClient> => {
        const response = await httpClient.get<MantaClient>(
          `/v1/clients/${id.value}`,
        );
        return response.data;
      },
      enabled: isEnabled,
      staleTime: 10_000,
    }),
  );
};
